/**
 * @file   src\validations\selectBay.ts
 * @brief  This file is responsible for defining select bay validation schemas.
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import * as yup from 'yup';
import { CommonMessages } from 'src/messages/validationMessages';

// Select Bay form validation schema.
export const SELECTBAY_SCHEMA = yup.object({
    bay: yup.string()
    .required(CommonMessages.bay),
});